module.exports = __webpack_public_path__ + "static/media/discount-banner.43ae2dac.jpg";